// PostNumbers.tsx — (tf3-35a) on the owner's video page beside the retention curve: each posted version's numbers per
// platform — views, reach, likes, comments, shares, saves (lib/post-numbers.ts for the words).
import { useEffect, useState } from "react";
import { videosApi } from "@/api/videos.ts";
import { NUMBER_COLUMNS, cell, statusOf, panelNote, needsDashNote, platformName, columnLabel, type PostNumbersAnswer } from "@/lib/post-numbers.ts";
import { w } from "@/lib/words.ts";   // (B107)

export function PostNumbers({ videoId }: { videoId: string }) {
  const [a, setA] = useState<PostNumbersAnswer | null>(null);
  const [err, setErr] = useState<string | null>(null);
  useEffect(() => {
    setErr(null);
    videosApi.postNumbers(videoId).then(setA).catch((e) => setErr(String((e as Error)?.message ?? e)));   // catch-reason: said in place of the table
  }, [videoId]);
  if (err) return <div style={{ margin: "10px 0", fontSize: 12, color: "#b91c1c" }}>{w("page.numbers.unread", { reason: err })}</div>;
  if (!a) return null;
  const note = panelNote(a);
  return (
    <div style={{ margin: "10px 0", padding: 10, background: "#f9fafb", borderRadius: 8, fontSize: 12 }} data-visual>
      <div style={{ fontWeight: 600, marginBottom: 4 }}>{w("page.numbers.title")}</div>
      {note ? <p className="tf-muted" style={{ margin: 0 }}>{note}</p> : (
        <>
          <table style={{ borderCollapse: "collapse" }}>
            <thead><tr><th style={{ textAlign: "left", paddingRight: 10 }}>{w("page.numbers.platform")}</th>{NUMBER_COLUMNS.map(([k]) => <th key={k} style={{ textAlign: "right", paddingRight: 10 }}>{columnLabel(k)}</th>)}</tr></thead>
            <tbody>{a.rows.map((r) => (
              <tr key={r.targetId}>
                <td style={{ paddingRight: 10 }}>{r.permalink ? <a href={r.permalink} target="_blank" rel="noreferrer">{platformName(r.channel)}</a> : platformName(r.channel)}</td>
                {statusOf(r) ? <td colSpan={NUMBER_COLUMNS.length} className="tf-muted">{statusOf(r)}</td>
                  : NUMBER_COLUMNS.map(([k]) => <td key={k} style={{ textAlign: "right", paddingRight: 10 }}>{cell(r, k)}</td>)}
              </tr>))}
            </tbody>
          </table>
          {needsDashNote(a.rows) && <p className="tf-muted" style={{ margin: "6px 0 0" }}>{w("page.numbers.not_reported")}</p>}
        </>
      )}
    </div>
  );
}
